import React from "react";
import { templateStrings } from "../../../../../../Constant";
import * as moment from "moment";
import PropTypes from "prop-types";

const FilterRouteIds = (val) => {
  return val.toString();
};

export const DeviceInfoItem = ({ label, value }) => {
  const displayLabel = templateStrings[label];

  const getDisplayValue = () => {
    if (label === "createdAt" || label === "updatedAt" || label === "lastPacketArrivedAt") {
      return value ? moment(value).format("DD MMM YYYY") : "NA";
    }

    if (label === "deviceStop") {
      return value?.stopId ?? "NA";
    }

    if (label === "routeIds" || label === "originatingRouteIds") {
      return value?.length ? FilterRouteIds(value) : "NA";
    }

    if (label === "stopName") {
      return value?.stopName ?? "N/A";
    }

    return value?.name ?? value ?? "NA";
  };

  return (
    <div className="row">
      <div>
        <span className="info-label">{displayLabel} :</span>
        <span className="info-value">{getDisplayValue()}</span>
      </div>
    </div>
  );
};

DeviceInfoItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};